/* sf-core-cart.js v3.18.0-rc.13 — CRITICAL add-to-cart behaviors, isolated from sf-core.js.
 * Load with its own <script> tag. Generated — do not edit in the theme. */
/* buy-buttons.js */
(function () {
try {
/* buy-buttons — AJAX add-to-cart for the PDP buy-buttons block.
 * Binds [data-ds-product-buy-buttons] (see blocks/ds-product-buy-buttons.liquid).
 *
 * Progressive enhancement: without JS the native product form still POSTs to
 * /cart/add and redirects to /cart. With JS it submits through the Shopify Cart
 * AJAX API (/cart/add.js then /cart.js) — the SAME session cart the theme, the
 * header count and checkout read (the Storefront API would create a separate
 * cart, so it is deliberately not used here) — then emits document events other
 * components react to instead of reaching into their markup:
 *   ds:cart:added   detail = the added line item
 *   ds:cart:updated detail = the full cart (has item_count)
 *   ds:cart:error   detail = { description } | { error }
 *
 * Copy is passed in via data-*-label on the root so this stays locale-agnostic.
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var BUY = '[data-ds-product-buy-buttons]';
var ADDON = '[data-ds-product-addon]';

function buyStatus(root, message) {
  var el = root.querySelector('[data-ds-buy-buttons-status]');
  if (el) el.textContent = message || '';
}

function buyBusy(form, busy) {
  var button = form.querySelector('button[type="submit"]');
  if (!button) return;
  button.disabled = busy;
  button.setAttribute('aria-busy', busy ? 'true' : 'false');
}

function buyLabel(root, name) {
  return root.getAttribute('data-' + name + '-label') || '';
}

function buySelectedAddons(form) {
  var scope = form.closest('[data-ds-product-section]') || document;
  var items = [];
  scope.querySelectorAll(ADDON).forEach(function (addon) {
    var selected = addon.querySelector('[data-ds-product-addon-select]');
    var quantity = addon.querySelector('[data-ds-product-addon-quantity] input[type="number"]');
    var variantId = addon.getAttribute('data-ds-product-addon-variant');
    if (!selected || !selected.checked || selected.disabled || !quantity || !variantId) return;

    var value = Math.max(1, Number(quantity.value) || 1);
    items.push({ id: variantId, quantity: value });
  });
  return items;
}

// Bundle grouping (Cross-sell Bundle spec §4). Shopify has no first-class
// parent/child line for "main product + add-on with its OWN quantity" — a Cart
// Transform Function would fuse them and destroy that independence — so main and
// add-ons stay ordinary, independent lines and the grouping travels in three
// hidden line item properties the cart reads back to render them as one bundle:
//   _bundle_group       shared id for every line of the bundle
//   _bundle_role        'main' | 'addon'
//   _bundle_item_index  '0' for main, '1'..'n' for add-ons
// The leading underscore keeps them out of checkout and the order confirmation.
function buyBundleGroupId() {
  var crypto = window.crypto;
  if (crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return 'bundle-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}

function buyBundleProperties(group, role, index) {
  return { _bundle_group: group, _bundle_role: role, _bundle_item_index: String(index) };
}

function buyRequest(form) {
  var addons = buySelectedAddons(form);
  // Not a bundle: the plain form POST body, exactly as the native submit sends it.
  if (!addons.length) return { body: new FormData(form), headers: null };

  var data = new FormData(form);
  var main = {
    id: data.get('id'),
    quantity: Math.max(1, Number(data.get('quantity')) || 1),
  };
  var properties = {};
  data.forEach(function (value, key) {
    var match = key.match(/^properties\[(.+)\]$/);
    if (match && typeof value === 'string' && value !== '') properties[match[1]] = value;
  });

  var sellingPlan = data.get('selling_plan');
  if (sellingPlan) main.selling_plan = sellingPlan;

  var group = buyBundleGroupId();
  main.properties = Object.assign(properties, buyBundleProperties(group, 'main', 0));
  addons.forEach(function (addon, index) {
    addon.properties = buyBundleProperties(group, 'addon', index + 1);
  });

  // Add-ons first (reversed), main last — the order the cart expects so the
  // bundle reads main-then-add-ons once Shopify lists the new lines.
  return {
    body: JSON.stringify({ items: addons.slice().reverse().concat([main]) }),
    headers: { 'Content-Type': 'application/json' },
  };
}

function buyAdd(form) {
  var root = form.closest(BUY);
  if (!root) return;
  var request = buyRequest(form);
  buyBusy(form, true);
  buyStatus(root, buyLabel(root, 'adding'));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: Object.assign(
      { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      request.headers || {}
    ),
    body: request.body,
  })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    })
    .then(function (added) {
      if (!added.ok) {
        var msg = (added.data && added.data.description) || buyLabel(root, 'error');
        buyStatus(root, msg);
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: added.data }));
        return null;
      }
      document.dispatchEvent(new CustomEvent('ds:cart:added', { detail: added.data }));
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: cart }));
          buyStatus(root, buyLabel(root, 'added'));
        });
    })
    .catch(function (error) {
      document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: { error: String(error) } }));
      // The AJAX layer itself failed (offline, blocked, or a non-JSON response).
      // Guarantee the add still happens by falling back to the native form POST
      // /cart/add — full-page, but the item lands in the cart. A business error
      // (sold out / 422) is handled above via res.ok === false, so we never loop
      // here. form.submit() does not fire a submit event, so this handler is not
      // re-entered.
      if (form && form.isConnected && typeof form.submit === 'function') {
        form.submit();
      } else {
        buyStatus(root, buyLabel(root, 'error'));
      }
    })
    .then(function () {
      buyBusy(form, false);
    });
}

if (!document.__dsBuyButtonsBound) {
  document.__dsBuyButtonsBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ds-pdp-preview]');
    if (!btn) return;
    var slot = btn.closest('#by-preview-slot');
    if (slot && slot.querySelector('#customily-preview-button, #btn-preview-custom, .by-preview-modal__preview-btn')) return;
    var section = btn.closest('[data-ds-product-section]') || document;
    var gallery = section.querySelector('[data-ds-gallery-zoom]');
    var image = gallery && gallery.querySelector('img');
    if (image) image.click();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form')) return;
    if (!form.closest(BUY)) return;
    // Let the native POST proceed if the AJAX primitives are unavailable.
    if (!window.fetch || !window.FormData || !window.CustomEvent) return;
    e.preventDefault();
    buyAdd(form);
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "buy-buttons" failed to initialise:', sfError);
}
})();

/* cart-count.js */
(function () {
try {
/* cart-count — keeps the header and sticky-cart-button badges in sync with cart
 * changes. Binds [data-ds-header-cart-count] (snippets/ds-header-utility.liquid)
 * and [data-ds-sticky-cart-count] (snippets/ds-sticky-cart-button.liquid), and
 * listens for the document event buy-buttons.js emits after an AJAX add.
 *
 * Progressive enhancement: without JS the badges still render the Liquid count
 * on load; this only updates them in place so an add reflects without a reload.
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

function dsCartCountSet(count) {
  var badges = document.querySelectorAll('[data-ds-header-cart-count], [data-ds-sticky-cart-count]');
  if (!badges.length) return;
  var n = Number(count) || 0;
  for (var i = 0; i < badges.length; i++) {
    badges[i].textContent = String(n);
    // Each badge is display:none at 0 and inline-flex otherwise; toggle both so
    // it can appear from an empty cart and hide when emptied.
    badges[i].classList.toggle('sf-hidden', n <= 0);
    badges[i].classList.toggle('sf-inline-flex', n > 0);
  }
}

// The badge counts MAIN products only: a cross-sell add-on rides along with its
// product and is not a piece of its own (Cross-sell Bundle spec §3.3). Add-ons
// are recognised by _bundle_role, the property the bundle is grouped by; the
// parent_relationship test also covers lines nested by a Shopify bundle app.
function dsCartIsAddon(item) {
  if (!item) return false;
  var properties = item.properties;
  return Boolean(item.parent_relationship || (properties && properties._bundle_role === 'addon'));
}

function dsCartMainItemCount(cart) {
  if (!cart || !Array.isArray(cart.items)) return Number(cart && cart.item_count) || 0;
  return cart.items.reduce(function (total, item) {
    return dsCartIsAddon(item) ? total : total + (Number(item && item.quantity) || 0);
  }, 0);
}

// The sticky cart FAB only makes sense once there is something to check out, so
// it hides on an empty cart. Liquid renders the initial state (inline display),
// and this clears/sets that inline display in step with the badge — count > 0
// counts ALL lines (add-ons included) since even an add-on-only cart is a cart.
function dsStickyCartToggle(cart) {
  var buttons = document.querySelectorAll('[data-ds-sticky-cart-button]');
  if (!buttons.length) return;
  var total = Number(cart && cart.item_count) || 0;
  for (var i = 0; i < buttons.length; i++) {
    buttons[i].style.display = total > 0 ? '' : 'none';
  }
}

if (!document.__dsCartCountBound) {
  document.__dsCartCountBound = true;

  document.addEventListener('ds:cart:updated', function (e) {
    var cart = e.detail || {};
    dsCartCountSet(dsCartMainItemCount(cart));
    dsStickyCartToggle(cart);
  });

  document.addEventListener('ds:cart:optimistic-count', function (e) {
    var delta = Number(e.detail && e.detail.delta) || 0;
    if (!delta) return;
    var badge = document.querySelector('[data-ds-header-cart-count], [data-ds-sticky-cart-count]');
    var current = Number(badge && badge.textContent) || 0;
    dsCartCountSet(Math.max(0, current + delta));
  });
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "cart-count" failed to initialise:', sfError);
}
})();

/* product-addon.js */
(function () {
try {
/* product-addon — completes nested add-on cart handling when an external product
 * SDK owns the main add-to-cart request. The normal ds buy-buttons path adds main
 * + add-ons atomically, grouped by the _bundle_group / _bundle_role /
 * _bundle_item_index line item properties. BuildYou bypasses that submit and emits
 * by:addToCartSuccess after adding the parent, so this listener finds the new
 * parent line key and attaches checked add-ons using parent_line_key.
 *
 * Authoring rules: src/behaviors/README.md. No import/export.
 */

var PRODUCT_ADDON = '[data-ds-product-addon]';

function productAddonItems(scope) {
  var items = [];
  scope.querySelectorAll(PRODUCT_ADDON).forEach(function (addon) {
    var selected = addon.querySelector('[data-ds-product-addon-select]');
    var quantity = addon.querySelector('[data-ds-product-addon-quantity] input[type="number"]');
    var variantId = addon.getAttribute('data-ds-product-addon-variant');
    if (!selected || !selected.checked || selected.disabled || !quantity || !variantId) return;
    items.push({ id: variantId, quantity: Math.max(1, Number(quantity.value) || 1) });
  });
  return items;
}

function productAddonSyncQuantity(addon) {
  var selected = addon.querySelector('[data-ds-product-addon-select]');
  var quantity = addon.querySelector('[data-ds-product-addon-quantity] input[type="number"]');
  if (!selected || !quantity) return;
  // The stepper stays in its resting (enabled) look regardless of the checkbox —
  // it is only inert when the add-on itself is unavailable. Selection is gated by
  // the checkbox alone (see productAddonItems), so an unchecked add-on is never
  // added no matter what quantity is shown.
  quantity.disabled = selected.disabled;
  quantity.dispatchEvent(new Event('input', { bubbles: true }));
}

function productAddonCartUrl(path) {
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  return (root || '/') + path;
}

function productAddonDetailKey(detail) {
  if (!detail) return '';
  if (detail.key) return detail.key;
  if (detail.item && detail.item.key) return detail.item.key;
  if (detail.data) return productAddonDetailKey(detail.data);
  if (Array.isArray(detail.items)) {
    for (var i = 0; i < detail.items.length; i += 1) {
      if (detail.items[i] && detail.items[i].key && !detail.items[i].parent_relationship) {
        return detail.items[i].key;
      }
    }
  }
  return '';
}

function productAddonParentKey(event, cart, scope) {
  var fromEvent = productAddonDetailKey(event && event.detail);
  if (fromEvent) return fromEvent;

  var idInput = scope.querySelector('[data-ds-product-buy-buttons] input[name="id"]');
  var variantId = idInput && String(idInput.value);
  var cartItems = (cart && cart.items) || [];
  for (var i = 0; i < cartItems.length; i += 1) {
    var item = cartItems[i];
    if (!item || item.parent_relationship) continue;
    if (!variantId || String(item.variant_id || item.id) === variantId) return item.key || '';
  }
  return '';
}

if (!document.__dsProductAddonBound) {
  document.__dsProductAddonBound = true;

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.closest || !select.matches('[data-ds-product-addon-select]')) return;
    var addon = select.closest(PRODUCT_ADDON);
    if (addon) productAddonSyncQuantity(addon);
  });

  // Stepping the quantity up is an implicit "yes, add this": tick the add-on's
  // checkbox on the first increment so the shopper does not have to select it
  // separately. Runs alongside number-input.js (which does the actual step) — this
  // only flips the checkbox, and only on increase, so decrementing never deselects.
  document.addEventListener('click', function (event) {
    var increase =
      event.target && event.target.closest
        ? event.target.closest('[data-ds-number-input-increase]')
        : null;
    if (!increase || increase.disabled) return;
    var addon = increase.closest(PRODUCT_ADDON);
    if (!addon) return;
    var select = addon.querySelector('[data-ds-product-addon-select]');
    if (!select || select.disabled || select.checked) return;
    select.checked = true;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function productAddonHandleSdkAddToCart(event) {
    var customization = document.querySelector('[data-ds-product-customization-form]');
    var scope = (customization && customization.closest('[data-ds-product-section]')) || document;
    var items = productAddonItems(scope);
    if (!items.length || !window.fetch || !window.CustomEvent) return;

    // When BuildYou is publishing the selected add-ons as cross-sell items
    // (window.BuildYou.crossSellItems, mirrored from window.ebUpsell by
    // ds-legacy-globals), the SDK already adds them in its OWN /cart/add.js request.
    // Re-adding them here would double them — Shopify rejects it with a 422 — and
    // the customization-form bridge already builds the Added-to-cart dialog from
    // those lines. Defer to it entirely.
    var by = window.BuildYou;
    if (by && Array.isArray(by.crossSellItems) && by.crossSellItems.length) return;

    var parentKey = '';
    fetch(productAddonCartUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        parentKey = productAddonParentKey(event, cart, scope);
        if (!parentKey) throw { description: 'Unable to identify the add-on parent line.' };
        items.forEach(function (item) { item.parent_line_key = parentKey; });
        return fetch(productAddonCartUrl('cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          // The just-added add-on lines. Tag each with the parent key so the
          // Added-to-cart dialog's isChild test always recognises it as a bundle
          // child, whatever /cart/add.js echoes back.
          var addons = data && Array.isArray(data.items) ? data.items : [];
          addons.forEach(function (line) { if (line) line.parent_line_key = parentKey; });
          return fetch(productAddonCartUrl('cart.js'), { headers: { Accept: 'application/json' } })
            .then(function (res2) { return res2.json(); })
            .then(function (cart) { return { cart: cart, addons: addons }; });
        });
      })
      .then(function (result) {
        var cart = result.cart;
        // One complete ds:cart:added — the parent product line plus its add-on
        // children — so the dialog shows the product, the add-on rows AND a total
        // that includes both. buy-buttons.js sends both in one request and gets
        // this shape for free; the BuildYou path adds the add-ons separately, so it
        // is assembled here. This event runs one request later than the
        // customization-form bridge's product-only event, so it lands last and the
        // add-ons it paints are never re-hidden. Falls back to the add-on lines
        // alone if the parent line can't be located in the fresh cart.
        var parentLine = null;
        var lines = (cart && cart.items) || [];
        for (var i = 0; i < lines.length; i += 1) {
          if (lines[i] && lines[i].key === parentKey) { parentLine = lines[i]; break; }
        }
        var detailItems = parentLine ? [parentLine].concat(result.addons) : result.addons;
        document.dispatchEvent(new CustomEvent('ds:cart:added', { detail: { items: detailItems } }));
        document.dispatchEvent(new CustomEvent('ds:cart:updated', { detail: cart }));
      })
      .catch(function (error) {
        document.dispatchEvent(new CustomEvent('ds:cart:error', { detail: error }));
      });
  }

  window.addEventListener('by:addToCartSuccess', productAddonHandleSdkAddToCart);
  window.addEventListener('eb-add-to-cart-success', productAddonHandleSdkAddToCart);
}

} catch (sfError) {
if (typeof console !== 'undefined') console.error('[sf-core] behavior "product-addon" failed to initialise:', sfError);
}
})();
